import React from "react";
import { useSelector } from "react-redux";

import ProductsDescriptionHtml from "./productsDescriptionHtml";

function ProductDescriptionV3(props) {
  const language = useSelector((state) => state.Layout.language);

  if (!props.product?.translations) {
    return <div></div>;
  }

  let translation = props.product.translations.find(
    (translation) => translation?.locale === language
  );

  // fallback to en-US if no translation is found
  if (!translation) {
    translation = props.product.translations.find(
      (translation) => translation?.locale === "en-US"
    );
  }
  // if no translation is found, return an empty div
  if (!translation?.detailsHtml) {
    return <div></div>;
  }

  return (
    <ProductsDescriptionHtml
      html={translation.detailsHtml}
    ></ProductsDescriptionHtml>
  );
}

export default ProductDescriptionV3;